<p-dialog
  header="Seguridad de tu cuenta"
  [visible]="authService.forceChangePasswordPromptVisible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="force-change-password-dialog"
>
  <p class="dialog-copy">
    Por tu seguridad, te recomendamos cambiar la contraseña temporal que te
    proporcionamos. ¿Deseas cambiarla ahora?
  </p>

  <div class="dialog-actions">
    <p-button
      label="Mantener actual"
      severity="secondary"
      [outlined]="true"
      (onClick)="onPromptKeepPassword()"
      [loading]="submitting"
    />
    <p-button
      label="Sí, cambiar contraseña"
      severity="success"
      (onClick)="onPromptChangePassword()"
      [disabled]="submitting"
    />
  </div>
</p-dialog>

<p-dialog
  header="Cambiar contraseña"
  [visible]="authService.forceChangePasswordFormVisible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="force-change-password-dialog"
>
  <form [formGroup]="form" class="force-change-form" (ngSubmit)="submit()">
    <label class="field-label" for="force-change-username">Usuario</label>
    <input
      id="force-change-username"
      pInputText
      formControlName="username"
      class="full-width"
      readonly
    />

    <ng-container *ngIf="showCurrentPasswordField">
      <label class="field-label" for="force-change-current">Contraseña actual</label>
      <p-password
        inputId="force-change-current"
        formControlName="currentPassword"
        [toggleMask]="true"
        [feedback]="false"
        styleClass="full-width"
        inputStyleClass="full-width"
      />
    </ng-container>

    <label class="field-label" for="force-change-new">Nueva contraseña</label>
    <p-password
      inputId="force-change-new"
      formControlName="newPassword"
      [toggleMask]="true"
      [feedback]="false"
      styleClass="full-width"
      inputStyleClass="full-width"
    />
    <small
      class="field-error"
      *ngIf="form.get('newPassword')?.touched && form.get('newPassword')?.hasError('minlength')"
    >
      La contraseña debe tener al menos 6 caracteres.
    </small>

    <label class="field-label" for="force-change-confirm">Repetir nueva contraseña</label>
    <p-password
      inputId="force-change-confirm"
      formControlName="confirmPassword"
      [toggleMask]="true"
      [feedback]="false"
      styleClass="full-width"
      inputStyleClass="full-width"
    />

    <small class="field-error" *ngIf="passwordsDoNotMatch()">
      Las contraseñas no coinciden.
    </small>
    <small class="field-error" *ngIf="samePassword()">
      La nueva contraseña debe ser distinta a la actual.
    </small>

    <div class="dialog-actions">
      <p-button
        type="button"
        label="Mantener actual"
        severity="secondary"
        [outlined]="true"
        (onClick)="onPromptKeepPassword()"
        [disabled]="submitting"
      />
      <p-button
        type="submit"
        label="Guardar contraseña"
        severity="success"
        [loading]="submitting"
        [disabled]="isSubmitDisabled()"
      />
    </div>
  </form>
</p-dialog>
